/* 报告名称：alage-日期-6位随机数字
例子：alage-220302-478232

groupType: {key: 'alage', name: '淡水藻类'}

blastLibraryId: 读一个json配置文件 */
import Vue from 'vue'
import Vuex from 'vuex'
import http from '../utils/http'
import api from '../utils/api'
import { Message } from 'element-ui'
import Router from '../router/index'

Vue.use(Vuex)
let typeConfig = [
  { key: 'MYCO', name: '结核病' },
  { key: 'HIV', name: 'HIV分子网络' },
  { key: 'covid19', name: '新冠病毒' },
  { key: 'alage', name: '淡水藻类' }
]
function MathRand (n) {
  var Num = ''
  for (var i = 0; i < n; i++) {
    Num += Math.floor(Math.random() * 10)
  }
  return Num
}
const store = new Vuex.Store({
  // 放全局参数
  state: {
    // 是否登录
    isEnroll: false,
    needEnroll: false,
    name: '',
    blast: {},
    sequences: {
      mode: '',
      text: '',
      textArray: [],
      textPath: '',
      sourceDatabaseId: '',
      sourceDatabaseName: '',
      sampleNameArray: []
    },
    submitData: {},
    curType: typeConfig[3],
    jobTitle: `alage-${MathRand(6)}-${MathRand(6)}`,
    hasSubmit: false,
    blastVal: 'BLASTN',
    textCheckPass: true
    // speciesPage: 1
  },
  // 放全局方法
  mutations: {
    undateBlastVal (state, val) {
      state.blastVal = val
    },
    // undateSpeciesPage (state, val) {
    //   state.speciesPage = val
    // },
    updateSequences (state, obj) {
      state.sequences = { ...state.sequences, ...obj }
      // 1.state.sequences = {}  等于新对象
      // 2.将原本的state.sequences赋值给新的对象
      // 3.state.sequences和obj进行对比，将相同key的value覆盖，新的key添加到state.sequences
    },
    /* Blast */
    updateBlastData (state, obj) {
      state.blast = obj
    },
    // 回到顶部
    toTop () {
      scrollTo({
        top: 0
      })
    },
    getName (state, name) {
      state.name = name
    },
    textCheck (state, val) {
      state.textCheckPass = false
      let indexStart = val.indexOf('>')
      let indexEnd = val.indexOf('\n', indexStart + 1)
      let indexMid = val.indexOf(':', indexStart + 1)
      let num = 0
      while (indexStart !== -1 && indexEnd !== -1 && num === 0) {
        if (indexMid > indexStart && indexMid < indexEnd) {
          num++
        }
        indexStart = val.indexOf('>', indexStart + 1)
        indexEnd = val.indexOf('\n', indexStart + 1)
        indexMid = val.indexOf(':', indexStart + 1)
      }
      if (num === 0) {
        state.textCheckPass = true
      }
    }
  },
  actions: {
    async getEnrollState ({ state }) {
      let res = await api.getSetCheckLogin()
      if (res === '') {
        state.needEnroll = false
        state.isEnroll = false
      } else {
        state.needEnroll = true
        if (res.data && res.data.code === 200) {
          state.isEnroll = true
          http.get(
            `/web/selectUserByUserName?pusername=${res.msg}`,
            {},
            res => {
              if (res.code === 200) {
                state.name = res.data.name
              }
            }
          )
        } else {
          state.isEnroll = false
        }
      }
    },
    checkAndSetBlastParam ({ state }) {
      return new Promise((resolve, reject) => {
        for (let key in state.blast) {
          if (
            state.blast[key] === '' ||
            state.blast[key] === null ||
            typeof state.blast[key] === 'undefined'
          ) {
            // resolve({ code: 500, data: null, msg: 'Blast配置未完善' })
            resolve({
              code: 500,
              data: null,
              msg: 'Blast configuration is not perfect'
            })
            break
          }
        }
        let blast = {}
        blast.libraryId = state.blast.library
        blast.analysisClass = 'input'
        blast.max_target_seqs = state.blast.maxTargetSeq
        blast.evalue = state.blast.threshold
        blast.word_size = state.blast.wordSize
        blast.culling_limit = state.blast.maxMatches
        blast.gapopen = Number(state.blast.gapCostsFrom)
        blast.gapextend = Number(state.blast.gapCostsTo)
        blast.database = state.blast.database
        blast.withoutPosition = ''
        if (state.blastVal === 'BLASTN') {
          blast.task = state.blast.optimize
          blast.penalty = Number(state.blast.matchScoresTo)
          blast.reward = Number(state.blast.matchScoresFrom)
          blast.blastClass = 'blastn'
        } else if (state.blastVal === 'BLASTP') {
          blast.matrix = state.blast.matrix
          blast.comp_based_stats = state.blast.compositional
          blast.blastClass = 'blastp'
          blast.task = 'blastp'
        }
        // blast.dotree = state.blast.dotree
        resolve({ code: 200, data: { blast }, msg: 'Success' })
      })
    },
    async handleSubmitData ({ state, dispatch, commit }) {
      state.hasSubmit = true
      state.submitData = {}
      let checkArray = ['checkAndSetBlastParam']
      for (let i = 0; i < checkArray.length; i++) {
        const { code, data, msg } = await dispatch(checkArray[i])
        if (code === 500) {
          if (msg) Message.error(msg)
          state.hasSubmit = false
          return false
        } else {
          if (code === 200) {
            for (let key in data) {
              if (Object.keys(data[key]).length) {
                Object.defineProperty(state.submitData, key, {
                  value: data[key],
                  writable: true,
                  enumerable: true,
                  configurable: true
                })
              } else {
                state.submitData[key] = {}
              }
            }
          }
        }
      }
      let data = ''
      if (state.sequences.mode === 'raw-input') {
        if (!state.sequences.text || !state.sequences.textArray.length) {
          state.hasSubmit = false
          return Message.error('Please enter the correct FASTA sequence!')
        }
        commit('textCheck', state.sequences.text)
        if (!state.textCheckPass) {
          state.hasSubmit = false
          return Message.error('HeaderID can not contain ":" symbol, please modify and resubmit')
        }
        data = 'byte_data:' + state.sequences.text
      } else if (state.sequences.mode === 'upload-file') {
        if (!state.sequences.textPath) {
          state.hasSubmit = false
          return Message.error('Please upload the correct file')
        }
        data = 'localfs:' + state.sequences.textPath
      } else {
        data = state.sequences.sampleNameArray
          .map(
            s => 'genedb_sample:' + state.sequences.sourceDatabaseName + ',' + s
          ).join('\n')
      }
      state.submitData.data = { data }
      const params = {
        groupName: state.jobTitle,
        groupType: state.curType.key
      }
      let url = `/virusdb/commitTaskGroup?groupName=${params.groupName}&groupType=${params.groupType}`
      http.post(
        url,
        JSON.stringify(state.submitData),
        res => {
          if (res.code !== 200) {
            state.hasSubmit = false
            Message.error('Failed to submit analysis')
            return false
          } else {
            Message.success(
              'Submit analysis successfully, go to the report page'
            )
            setTimeout(() => {
              state.hasSubmit = false
              Router.push({
                name: 'BlaseResult',
                query: { taskGroupId: res.data.group.taskGroupId }
              })
            }, 1000)
          }
        },
        {
          headers: {
            'Content-Type': 'application/json'
          }
        }
      )
    }
  }
})
// 抛出全局函数，给外部引用
export default store



// WEBPACK FOOTER //
// ./src/store/index.js